"use client";
import { useParams } from "next/navigation";
import { getTranslations, Locale } from "./config";

export const useTranslations = () => {
  const params = useParams();
  const locale = (params?.locale as Locale) || "de";
  const t = getTranslations(locale);
  return t;
};
